import { render, staticRenderFns } from "./ProvidentFund.vue?vue&type=template&id=55706735&scoped=true&"
import script from "./ProvidentFund.vue?vue&type=script&lang=js&"
export * from "./ProvidentFund.vue?vue&type=script&lang=js&"
import style0 from "./ProvidentFund.vue?vue&type=style&index=0&id=55706735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55706735",
  null
  
)

export default component.exports